import routes from 'router/routes'
import { createDrawerRouterSlice, getInitialDrawerRouterState } from 'slices/generic/createDrawerRouterSlice'
import { get } from 'utils/lodash'

import type { PayloadAction } from '@reduxjs/toolkit'

type ReportingDrawerState = {
  reportingDrawer?: {
    isDrawerOpen?: boolean
    favoriteUrl?: string
  }
}

/** `createDrawerRouterSlice` is untyped JS, so the generated actions are declared here. */
type ReportingDrawerActions = {
  openDrawer: () => PayloadAction<undefined>
  closeDrawer: () => PayloadAction<undefined>
  setIsDrawerOpen: (isOpen: boolean) => PayloadAction<boolean>
  setFavoriteUrl: (url: string) => PayloadAction<string>
}

const reportingDrawerSlice = createDrawerRouterSlice({
  name: 'reportingDrawer',
  initialState: getInitialDrawerRouterState({ favoriteUrl: routes.app.reportingDashboard }),
  reducers: {},
})

export const {
  openDrawer: openReportingDrawer,
  closeDrawer: closeReportingDrawer,
  setIsDrawerOpen: setIsOpenReportingDrawer,
  setFavoriteUrl: setFavoriteReportingUrl,
} = reportingDrawerSlice.actions as unknown as ReportingDrawerActions

export const selectIsOpenReportingDrawer = (state: ReportingDrawerState) => get(state, 'reportingDrawer.isDrawerOpen', true)
export const selectReportingFavoriteUrl = (state: ReportingDrawerState) =>
  get(state, 'reportingDrawer.favoriteUrl', routes.app.reportingDashboard)

export default reportingDrawerSlice.reducer
